import React from 'react';

export const NotFoundPage = () => (
    <>
        <img alt="404" src="Images/404.svg" className="m-auto my-10 h-4/5 w-3/5 block" />
        <p className="text-center mt-2 text-2xl">The page isn't available. Sorry!</p>
    </>
);
